type Rg4jsFn = (...args: unknown[]) => void;

function getRg4js(): Rg4jsFn | undefined {
  const rg = (globalThis as unknown as { rg4js?: unknown }).rg4js;
  return typeof rg === 'function' ? (rg as Rg4jsFn) : undefined;
}

/** True only after successful apiKey configuration (matches Web Portal rg4js usage). */
let raygunConfigured = false;

export const initializeRaygun = (): boolean => {
  if (raygunConfigured) return true;

  const apiKey = import.meta.env.VITE_APP_RAYGUN_API_KEY;
  const rg4js = getRg4js();
  if (!apiKey || !rg4js) {
    return false;
  }

  rg4js('apiKey', apiKey);
  rg4js('enableCrashReporting', true);
  rg4js('setVersion', import.meta.env.VITE_APP_VERSION || 'unknown');
  rg4js('withTags', [import.meta.env.MODE]);
  rg4js('options', {
    ignoreAjaxAbort: true,
    ignoreAjaxError: false,
  });

  raygunConfigured = true;
  return true;
};

export const trackRaygunError = (error: Error, customData?: Record<string, unknown>): void => {
  if (!raygunConfigured) return;
  const rg4js = getRg4js();
  if (!rg4js) return;
  try {
    rg4js('send', { error, customData });
  } catch (e) {
    console.error('[Raygun] Failed to send error:', e);
  }
};

export const setRaygunUser = (userId: string, email?: string, fullName?: string): void => {
  if (!raygunConfigured) return;
  const rg4js = getRg4js();
  if (!rg4js) return;
  rg4js('setUser', {
    identifier: userId,
    isAnonymous: false,
    email,
    fullName,
  });
};
